import "./loader.css"
import { useEffect } from "react";

function RouteLoader({ isRouteLoading, setIsRouteLoading }) {
    useEffect(() => {
        if (isRouteLoading) {
            setTimeout(() => {
                setIsRouteLoading(false);
            }, 1);
        }
    }, [isRouteLoading, setIsRouteLoading]);

    return (
        <div className='route-loader'></div>
    )
}

export default RouteLoader
